export default {
  bulletimeLocalStorageKey: "BULLETIME",
  configPanelOpenCacheKey: "CORE.CONFIG_PANEL_OPEN",
};
